<template>
  <v-container>
    <v-layout column align-center>
      <v-card class="nav-menu gestion-menu">
        <v-bottom-nav
          :active.sync="bottomNav"
          :color="color"
          :value="true"
          shift
        >
          <v-btn
            dark
            v-for="item in items"
            :key="item.title"
            @click="enrutarA(item.link)"
          >
            <span>{{ item.title }}</span>
            <v-icon>{{ item.icon }}</v-icon>
          </v-btn>
        </v-bottom-nav>
        <router-view v-on:changeBottomNav="bottomNav = $event"></router-view>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "Gestion",
  data() {
    return {
      bottomNav: 0,
      vista: "expedientes"
    };
  },
  created() {
    // Object.assign(this.originalUser, this.usuario)
    // this.setUser()
    // this.setLevel()

    this.setUsers();
    this.setUsersPreReg();
    this.setExpedientes();
    this.setCatastro();

    // this.setProvincias()
    // this.setComunidades()
    // this.setExpedientesStatus()
  },
  computed: {
    items() {
      // <!-- <v-btn dark :disabled="!expedienteSelected"> -->
      // <!-- <v-btn dark :disabled="!userEditActive"> -->
      return this.$store.getters.getItemsGestionMenu;
    },
    color() {
      switch (this.bottomNav) {
        case 0:
          return "blue lighten-1";
        case 1:
          return "teal";
        case 2:
          return "brown";
        case 3:
          return "red";
        case 4:
          return "blue-grey";
        default:
          return "green";
      }
    }
  },
  methods: {
    setUser() {
      this.$store.dispatch("setUser");
    },
    setUsers() {
      this.$store.dispatch("setUsers");
    },
    setLevel() {
      this.$store.dispatch("setLevel");
    },
    setUsersPreReg() {
      this.$store.dispatch("setUsersPreReg");
    },
    setExpedientes() {
      this.$store.dispatch("setExpedientes");
    },
    setExpedientesStatus() {
      this.$store.dispatch("setExpedientesStatus");
    },
    setCatastro() {
      this.$store.dispatch("setCatastro");
    },
    setProvincias() {
      this.$store.dispatch("setProvincias");
    },
    setComunidades() {
      this.$store.dispatch("setComunidades");
    },
    enrutarA(lnk) {
      if (lnk) {
        this.$router.push(lnk);
      }
    }
  }
};
</script>

<style scoped>
.gestion-menu {
  width: 100%;
}
</style>
